import { faLocationDot } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router';

import { useGetPracticeGroups } from '@/react-query/insights/usePracticeGroups';

import { Breadcrumbs } from '../components/Breadcrumbs';
import { DashboardNavigator } from '../components/DashboardNavigator';
import { Filters } from '../components/filters/Filters';

export const RegionHeader = () => {
  const location = useLocation();
  const id =
    location.pathname.split('region/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('region/')[1]?.split('/')[0];

  const { data: practiceGroups } = useGetPracticeGroups();

  const selectedPractices = practiceGroups?.data
    .find((group) => group.id.toString() === id)
    ?.practices.map((practice) => practice.practiceVideaId);

  const name = practiceGroups?.data.find(
    (group) => group.id.toString() === id,
  )?.name;

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full">
      <Breadcrumbs />
      <div className="vai-flex vai-flex-row vai-gap-2 vai-items-center">
        {name && <FontAwesomeIcon icon={faLocationDot} />}
        <span className="vai-typography-h4">{name}</span>
      </div>
      <DashboardNavigator />
      <Filters
        selectedDrilldownPractices={selectedPractices}
        enableProviderRoleFilter={true}
        enableTasksFilter={location.pathname.includes('hygiene')}
        enableMaterialityFilter={location.pathname.includes('clinical')}
      />
    </div>
  );
};
